
<ll-titulo>Asociar Evaluacion a Generador #{{ generadorInstrumentoId }}</ll-titulo>

<generador-diagnostico-evaluacion [generadorInstrumentoId]="generadorInstrumentoId"></generador-diagnostico-evaluacion>
